import React from 'react';
import { Link } from 'react-router';
import Page from '../components/Page';

const NotFound = () => (
  <Page title="Page not found">
    <p className="text-gray-700">
      That page doesn&rsquo;t exist.{' '}
      <Link to="/" className="font-medium text-navy underline">
        Head back home
      </Link>
      .
    </p>
  </Page>
);

export default NotFound;
